import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import { FormField } from "@babackapp/ui/components/form";
import { useFormContext } from "react-hook-form";
import { DiscountSettingsFormValues } from "./discount-settings-form";
import {
  useDiscountDisabled,
  useDiscountModeIncompatibleDisabled,
  useFreeShippingFormDisabled,
} from "./use-form-section-disabled";
import useTranslation from "@babackapp/translations/use-translation";

function DiscountSettingsFreeShippingOptionsFields() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const discountDisabled = useDiscountDisabled();
  const freeShippingDisabled = useFreeShippingFormDisabled();
  const wrongModeDisabled = useDiscountModeIncompatibleDisabled();

  const disabled =
    discountDisabled || freeShippingDisabled || wrongModeDisabled;

  return (
    <FormInputRow>
      <FormField
        control={control}
        name="minimalDiscountForFreeShipping"
        render={({ field }) => (
          <FormInput
            label={t(
              "settings.config.discount.minimumAmountForFreeShipping.title",
            )}
            type="number"
            {...field}
            onChange={(e) => field.onChange(e.target.valueAsNumber)}
            disabled={disabled}
          />
        )}
      />

      <FormField
        control={control}
        name="freeShippingCode"
        render={({ field }) => (
          <FormInput
            label={t("settings.config.discount.freeShippingCode.title")}
            {...field}
            disabled={disabled}
          />
        )}
      />
    </FormInputRow>
  );
}

export default function DiscountSettingsFreeShippingForm() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const discountDisabled = useDiscountDisabled();
  const wrongModeDisabled = useDiscountModeIncompatibleDisabled();

  const disabled = discountDisabled || wrongModeDisabled;

  return (
    <>
      <FormField
        control={control}
        name="discountFreeShippingActivated"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.config.discount.freeShippingActivated.title")}
            description={t(
              "settings.config.discount.freeShippingActivated.description",
            )}
            {...field}
            disabled={disabled}
          />
        )}
      />

      <DiscountSettingsFreeShippingOptionsFields />
    </>
  );
}
